






















import { DynamicDocumentItem, InstallationModuleData, MechanicInstallation } from '@/types';

import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    moduleData: Object as PropType<InstallationModuleData>,
    installation: { type: Object as PropType<MechanicInstallation> },

    max: {
      type: Number,
      default: 50,
    },
  },

  mounted() {
    if (!this.moduleData.numberOfPanels) {
      this.value = this.installation.screening.numberOfPanels;
    }
  },

  computed: {
    value: {
      get(): number {
        return this.moduleData.numberOfPanels ?? 1;
      },

      set(val: number = 1) {
        if (val > this.max) val = this.max;
        else if (val <= 0) val = 1;

        this.$set(this.moduleData, 'numberOfPanels', val);
      },
    },
  },
});
